// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.property-filter form{
    display: flex;
    justify-content: space-between;
    gap: 1rem;
}
.property-filter form input{
    width: 100%;
    padding: 0.5rem;
    border: 1px solid #ccc;
    border-radius: 0.25rem;
}
.property-filter form select{
    width: 100%;
    padding: 0.5rem;
    border: 1px solid #ccc;
    border-radius: 0.25rem;
}
.property-filter form section label{
    display: block;
    margin-bottom: 0.5rem;
}
`, "",{"version":3,"sources":["webpack://./assets/css/PropertyFilter.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;AACb;AACA;IACI,WAAW;IACX,eAAe;IACf,sBAAsB;IACtB,sBAAsB;AAC1B;AACA;IACI,WAAW;IACX,eAAe;IACf,sBAAsB;IACtB,sBAAsB;AAC1B;AACA;IACI,cAAc;IACd,qBAAqB;AACzB","sourcesContent":[".property-filter form{\n    display: flex;\n    justify-content: space-between;\n    gap: 1rem;\n}\n.property-filter form input{\n    width: 100%;\n    padding: 0.5rem;\n    border: 1px solid #ccc;\n    border-radius: 0.25rem;\n}\n.property-filter form select{\n    width: 100%;\n    padding: 0.5rem;\n    border: 1px solid #ccc;\n    border-radius: 0.25rem;\n}\n.property-filter form section label{\n    display: block;\n    margin-bottom: 0.5rem;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
